import { render, staticRenderFns } from "./TableUnity.vue?vue&type=template&id=248672f2&"
import script from "./TableUnity.vue?vue&type=script&lang=js&"
export * from "./TableUnity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports